import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Decorative";
import { DIYA_PHOTO } from "../lib/constants";
import { ROUTES } from "../lib/seo";

/**
 * Home origin section — the short telling of where bhajan jamming began.
 * The fullest version lives on the pillar page (/what-is-bhajan-jamming/).
 */
export default function Origin() {
  return (
    <section className="relative overflow-hidden py-24 md:py-32 px-6" style={{ background: "#0F0A07" }} data-testid="origin-section">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 md:gap-16 items-center">
        <Reveal>
          <Eyebrow>Where it began</Eyebrow>
          <h2 className="mt-4 font-display text-4xl md:text-5xl leading-[1.05]" style={{ color: "#FBF6EE" }}>
            It began on a<br /><span className="gold-grad italic">boat, not a stage</span>
          </h2>
          <p className="mt-6 font-body text-base md:text-lg leading-relaxed" style={{ color: "#E8D9C5" }}>
            Bhajan jamming did not start in an auditorium. It started in Kashi, on the Ganga —
            voices carried over moving water by lamplight, drifting past Manikarnika, no sound
            system and no seating plan. There was no audience, only the people singing.
          </p>
          <p className="mt-4 font-body text-base md:text-lg leading-relaxed" style={{ color: "#E8D9C5" }}>
            Antara is that boat, made large enough for a city to sit in. The river sessions are
            still part of every <a href="https://kashiwithanshu.com/the-immersion/" target="_blank" rel="noopener noreferrer" className="underline underline-offset-4 decoration-[#C9A961]/60" style={{ color: "#E5C880" }}>Kashi with Anshu</a> immersion.
          </p>
          <Link to={ROUTES.pillar.path} className="mt-7 inline-flex items-center gap-2 font-body text-sm tracking-wide transition" style={{ color: "#E5C880" }} data-testid="origin-pillar-link">
            Read the full story <ArrowRight size={15} />
          </Link>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="relative">
            <div className="absolute -inset-3 rounded-[28px] bg-gradient-to-br from-[#C9A961]/25 to-transparent blur-xl" />
            <div className="relative aspect-[4/5] overflow-hidden rounded-[24px] border" style={{ borderColor: "rgba(201,169,97,0.3)" }}>
              <img src={DIYA_PHOTO} alt="A lamp set afloat on the Ganga at Kashi — where Antara's bhajan jamming began" width="800" height="1000" loading="lazy" decoding="async" className="w-full h-full object-cover" />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
